export default __webpack_public_path__ + "static/media/etavastaanotto.e85af6f2.svg";